import { Injectable } from '@angular/core';

import { BaseUiChangeHandler } from '../../../lib/ui-manager/base-ui-change-handler';
import { UiManagerService } from '../../../lib/ui-manager/ui-manager.service';
import { IUiState } from '../../../lib/ui-manager/ui-manager.state';
import { UiStates } from '../../../lib/ui-manager/ui-states.enum';
import { LineSwitcherDialogService } from './services/line-switcher-dialog.service';

@Injectable()
export class LineSwitcherUiChangeHandler extends BaseUiChangeHandler {
    constructor(
        protected override uiManager: UiManagerService,
        private lineSwitcherDialogService: LineSwitcherDialogService,
    ) {
        super(uiManager);
    }

    updateUi(prev: IUiState, next: IUiState): void | Promise<any> {
        if (this.isStateRemoved(prev, next, UiStates.LineSwitcher)) {
            this.lineSwitcherDialogService.closeModalDialog();
        }
    }
}
